import { useState, useEffect, useRef } from 'react';

export const useMidiInput = () => {
    const [midiAccess, setMidiAccess] = useState(null);
    const [inputs, setInputs] = useState([]);
    const [activeNotes, setActiveNotes] = useState({
        0: false, // Straight Key
        1: false, // Dit
        2: false  // Dah
    });

    const midiAccessRef = useRef(null);

    useEffect(() => {
        if (!navigator.requestMIDIAccess) {
            console.warn('Web MIDI API not supported');
            return;
        }

        const onMIDIMessage = (event) => {
            const [command, note, velocity] = event.data;

            // Note On (144) or Note Off (128)
            // Some devices send Note On with velocity 0 for Note Off
            const isNoteOn = (command & 0xf0) === 144 && velocity > 0;
            const isNoteOff = (command & 0xf0) === 128 || ((command & 0xf0) === 144 && velocity === 0);

            if (isNoteOn || isNoteOff) {
                if ([0, 1, 2].includes(note)) {
                    setActiveNotes(prev => ({
                        ...prev,
                        [note]: isNoteOn
                    }));
                }
            }
        };

        navigator.requestMIDIAccess().then((access) => {
            setMidiAccess(access);
            midiAccessRef.current = access;
            setInputs(Array.from(access.inputs.values()));

            const onStateChange = (e) => {
                setInputs(Array.from(access.inputs.values()));
            };

            access.onstatechange = onStateChange;

            // Attach listeners to all current inputs
            access.inputs.forEach(input => {
                input.onmidimessage = onMIDIMessage;
            });

        }, (err) => {
            console.error('MIDI Access Failed', err);
        });

        return () => {
            if (midiAccessRef.current) {
                midiAccessRef.current.inputs.forEach(input => {
                    input.onmidimessage = null;
                });
                midiAccessRef.current.onstatechange = null;
            }
        };
    }, []);

    // Re-attach listeners if inputs list changes (e.g. new device plugged in)
    useEffect(() => {
        if (midiAccess) {
            const onMIDIMessage = (event) => {
                const [command, note, velocity] = event.data;
                const isNoteOn = (command & 0xf0) === 144 && velocity > 0;
                const isNoteOff = (command & 0xf0) === 128 || ((command & 0xf0) === 144 && velocity === 0);

                if (isNoteOn || isNoteOff) {
                    if ([0, 1, 2].includes(note)) {
                        setActiveNotes(prev => ({
                            ...prev,
                            [note]: isNoteOn
                        }));
                    }
                }
            };

            midiAccess.inputs.forEach(input => {
                input.onmidimessage = onMIDIMessage;
            });
        }
    }, [inputs, midiAccess]);

    return {
        isMidiAvailable: !!midiAccess,
        inputs,
        activeNotes
    };
};
